module.exports = __webpack_public_path__ + "static/media/13.49fa7c3b.jpg";